import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Autocomplete2 from "@material-ui/lab/Autocomplete";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import NumberFormat from "react-number-format";
import firebase2 from "../../../firebase";
import Permiso from "../../../Permiso";
import Autocomplete from "./Autocomplete";
import AddDialog from "./Fases/AddDialog";
import Conclusion from "./Fases/Conclusion";
import styles from "./styles";
import SnackBar from "./SnackBar";
const firebase = require("firebase");
require("firebase/firestore");

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

function NumberFormatCustomPercen(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator
      isNumericString
      prefix="%"
    />
  );
}

NumberFormatCustomPercen.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
class EditorComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      guardado: false,
      exito: false,
      text: "",
      domicilio: "",
      telefono: "",
      celular: "",
      email: "",
      curp: "",
      rfc: "",
      aseguradora: "",
      addAseguradora: false,
      ramo: "",
      addRamo: false,
      tiposeguro: "",
      addTiposeguro: false,
      asunto: "",
      addAsunto: false,
      monto: "",
      descripcion: "",
      contrato: false,
      honorarios: "",
      anticipo: "",
      asignadoA: "",
      recomendado: "",
      title: "",
      id: "",
      estado: 1,
      descr: "Actualizacion datos generales",
      open: false,
      open2: false,
      openAdd: false,
      addText: "",
      addMateria: "",
      addSeccion: "",
      creadoFecha: null,
      indexTab: 0
    };
  }

  componentDidMount = async () => {
    this.Autorizacion();
    //var Autorizacion = localStorage.getItem("Permisos");
    //const notaSeleccionada = await this.props.notes[this.props.index];
    const notaSeleccionada = this.props.notes
      ? this.props.notes.filter(i => i.id === this.props.selectedNote.id)[0]
      : [];
    await this.setState({
      text: notaSeleccionada.body,
      title: notaSeleccionada.title,
      domicilio: notaSeleccionada.domicilio,
      telefono: notaSeleccionada.telefono,
      celular: notaSeleccionada.celular,
      email: notaSeleccionada.email,
      curp: notaSeleccionada.curp,
      rfc: notaSeleccionada.rfc,
      aseguradora: notaSeleccionada.aseguradora,
      ramo: notaSeleccionada.ramo,
      tiposeguro: notaSeleccionada.tiposeguro,
      asunto: notaSeleccionada.asunto,
      monto: notaSeleccionada.monto,
      descripcion: notaSeleccionada.descripcion,
      contrato: notaSeleccionada.contrato,
      honorarios: notaSeleccionada.honorarios,
      anticipo: notaSeleccionada.anticipo,
      asignadoA: notaSeleccionada.asignadoA,
      recomendado: notaSeleccionada.recomendado,
      estado: notaSeleccionada.estado,
      creadoFecha: notaSeleccionada.creadoFecha,
      id: notaSeleccionada.id
    });
  };
  componentDidUpdate = () => {
    if (this.props.selectedNote.id !== this.state.id) {
      console.log(
        "componentDidUpdate",
        this.props.notes,
        this.props.selectedNote
      );
      this.setState({
        text: this.props.selectedNote.body,
        title: this.props.selectedNote.title,
        domicilio: this.props.selectedNote.domicilio,
        telefono: this.props.selectedNote.telefono,
        celular: this.props.selectedNote.celular,
        email: this.props.selectedNote.email,
        curp: this.props.selectedNote.curp,
        rfc: this.props.selectedNote.rfc,
        aseguradora: this.props.selectedNote.aseguradora,
        ramo: this.props.selectedNote.ramo,
        tiposeguro: this.props.selectedNote.tiposeguro,
        asunto: this.props.selectedNote.asunto,
        monto: this.props.selectedNote.monto,
        descripcion: this.props.selectedNote.descripcion,
        contrato: this.props.selectedNote.contrato,
        honorarios: this.props.selectedNote.honorarios,
        anticipo: this.props.selectedNote.anticipo,
        asignadoA: this.props.selectedNote.asignadoA,
        recomendado: this.props.selectedNote.recomendado,
        creadoFecha: this.props.selectedNote.creadoFecha,
        id: this.props.selectedNote.id
      });
    }
  };

  Autorizacion() {
    async function foo() {
      const k = new Permiso(); //Aqui hago instancia para llamar a la function que esta en Permiso.js
      const g = await k.Permiso(function(ans) {
        //aqui la llamo y le paso una funcion como parametro

        window.respuesta = ans;
        window.respuestaA = window.respuesta.checkedA;

        return ans;
      });

      return g;
    }
    //this.setState({ open: await foo() })

    foo();
    //AAQUI pero llega indefinida la varuiable, de hecho lo que pongo aqui se ejecuta antes, jijitl
    // console.log(y, "hay algo aqui? no lo hay")
    // console.log(await foo()," el foo a ver que pedo!!!!!!!")
    //console.log(window.respuesta, "log final de la asignacion de la variable global")
  }

  render() {
    const { classes, datosAutoc } = this.props;
    return (
      <div className={classes.editorContainer}>
        <Paper className={classes.paper}>
          <div style={{ width: "100%", marginRight: "10px", display: "flex" }}>
            <Typography>
              Caso creado:{" "}
              {this.state.creadoFecha
                ? moment(this.state.creadoFecha.toDate()).format("DD/MM/YYYY")
                : ""}
            </Typography>
          </div>
          <div style={{ width: "100%", marginRight: "10px", display: "flex" }}>
            <TextField
              style={{ width: "20%" }}
              id="outlined-name"
              label="Caso"
              className={classes.textField}
              //style={{ width: "380px" }}
              value={this.state.title ? this.state.title : ""}
              onChange={e => this.updateTitle(e.target.value)}
              margin="normal"
              variant="outlined"
            />

            {/*<TextField
              style={{ width: "380px" }}
              id="outlined-name" 
              label="Nombre del Cliente"
              className={classes.textField}
              value={this.state.text}
              onChange={e => this.updateBody(e.target.value)}
              margin="normal"
              variant="outlined"
            />
                         <Autocomplete
                update={this.updateRamo}
                onCloseAutocomplete={this.onCloseAutocompleteRamo}
                datosAutoc={
                  this.props.usuarios
                    ? this.props.usuarios.filter(i => i.rol === "cliente")
                    : null
                }
                text={""}
                nameFiled={"usuario"}
              />*/}
            <div style={{ width: "20%", marginRight: "10px", diplay: "flex" }}>
              <Autocomplete2
                id="combo-box-nombre"
                // className={classes.textField}
                value={this.state.text}
                onChange={(obj, str) => this.updateNombre(str)}
                onClose={params =>
                  console.log(params.target.value, "on closee!!")
                }
                // freeSolo
                options={
                  this.props.usuarios
                    ? this.props.usuarios
                        .filter(i => i.rol === "cliente")
                        .map(i => {
                          return i.nombre;
                        })
                    : null
                }
                // getOptionLabel={option => option.nombre}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Cliente"
                    margin="normal"
                    variant="outlined"
                    className={classes.textField}
                    fullWidth
                  />
                )}
              />
            </div>
            {/*window.respuesta.checkedH ? (
              <div style={{ width: "5%", display: "flex" }}>
                <IconButton
                  style={{ width: "40px" }}
                  aria-label="delete"
                  color="primary"
                  onClick={() => this.setState({ open2: true })}
                >
                  <AddCircleIcon />
                </IconButton>
              </div>
            ) : null */}
            {/* <div style={{ width: "20%", marginRight: "10px" }}>
       <Autocomplete2
        id="combo-box-email"
       // className={classes.textField}
        value={this.state.email}
        onChange={(obj, str) => this.updateEmail(str)}
        onClose={params => console.log(params.target.value,"on closee!!")}
       
        options={
          this.props.usuarios
            ? this.props.usuarios.filter(i => i.rol === "cliente").map(i => {return i.email})
            : null
        }
       // getOptionLabel={option => option.nombre}
        renderInput={params => (
         
          <TextField
            {...params}
            
            label="email"
            margin="normal"
            variant="outlined"
            className={classes.textField}
            fullWidth
            
          />
        )}
      /> 
      </div>*/}
            <TextField
              style={{ width: "20%" }}
              label="Correo Electronico"
              value={this.state.email}
              onChange={e => this.updateEmail(e.target.value)}
              className={classes.textField}
              disabled
              margin="normal"
              variant="outlined"
            />
            <TextField
              style={{ width: "20%" }}
              label="Domicilio"
              value={this.state.domicilio}
              onChange={e => this.updateDomicilio(e.target.value)}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />
          </div>
          {/*</Paper>
        <Paper className={classes.paper} style={{  display: "flex" }}>*/}
          <div style={{ width: "100%", marginRight: "10px" }}>
            <TextField
              label="Telefono"
              value={this.state.telefono}
              onChange={e => this.updateTelefono(e.target.value)}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="Celular"
              value={this.state.celular}
              onChange={e => this.updateCelular(e.target.value)}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="Curp"
              value={this.state.curp}
              onChange={e => this.updateCurp(e.target.value)}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="RFC"
              value={this.state.rfc}
              onChange={e => this.updateRFC(e.target.value)}
              className={classes.textField}
              disabled
              margin="normal"
              variant="outlined"
            />
          </div>
        </Paper>
        <Paper className={classes.paper}>
          <div style={{ width: "100%", display: "flex" }}>
            <Autocomplete
              update={this.updateRamo}
              onCloseAutocomplete={this.onCloseAutocompleteRamo}
              datosAutoc={
                datosAutoc
                  ? datosAutoc.filter(i => i.seccion === "materia" && i.activo)
                  : null
              }
              text={this.state.ramo}
              nameFiled={"Tipo de Materia"}
            />
            {this.state.addRamo ? (
              <IconButton
                style={{ width: "70px" }}
                aria-label="delete"
                color="primary"
                onClick={this.addRamo}
              >
                <AddCircleIcon />
              </IconButton>
            ) : null}
            <Autocomplete
              update={this.updateAseg}
              onCloseAutocomplete={this.onCloseAutocompleteS}
              datosAutoc={
                datosAutoc
                  ? datosAutoc
                      .filter(i => i.seccion === "instituciones" && i.activo)
                      .filter(i => i.materia === this.state.ramo)
                  : null
              }
              text={this.state.aseguradora}
              nameFiled={"Persona Fisica/Moral Demandada"}
            />
            {this.state.addAseguradora ? (
              <IconButton
                style={{ width: "70px" }}
                aria-label="delete"
                color="primary"
                onClick={this.addAseguradora}
              >
                <AddCircleIcon />
              </IconButton>
            ) : null}

            <Autocomplete
              update={this.updateSeguro}
              onCloseAutocomplete={this.onCloseAutocompleteTipoSeg}
              datosAutoc={
                datosAutoc
                  ? datosAutoc.filter(i => i.seccion === "reclamos" && i.activo)
                  : null
              }
              text={this.state.tiposeguro}
              nameFiled={"Tipo de Reclamacion"}
            />
            {this.state.addTiposeguro ? (
              <IconButton
                style={{ width: "70px" }}
                aria-label="delete"
                color="primary"
                onClick={this.addTiposeguro}
              >
                <AddCircleIcon />
              </IconButton>
            ) : null}
            <TextField
              label="Asunto"
              value={this.state.asunto}
              onChange={e => this.setState({ asunto: e.target.value })}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />
          </div>
          <FormControl component="fieldset">
            <FormLabel component="legend">Contrato Prst. Serv.</FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.contrato}
                    onChange={e =>
                      this.setState({ contrato: e.target.checked })
                    }
                    value="checkedA"
                    color="primary"
                  />
                }
                label="Si"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!this.state.contrato}
                    onChange={e =>
                      this.setState({ contrato: !e.target.checked })
                    }
                    value="checkedB"
                    color="primary"
                  />
                }
                label="No"
              />
            </FormGroup>
          </FormControl>
          <TextField
            label="Monto/Cuantia"
            value={this.state.monto}
            onChange={e => this.updateFianza(e.target.value)}
            InputProps={{
              inputComponent: NumberFormatCustom
            }}
            className={classes.textField}
            margin="normal"
            variant="outlined"
          />
          <TextField
            label="Honorarios"
            value={this.state.honorarios}
            onChange={e => this.updateHonor(e.target.value)}
            className={classes.textField}
            margin="normal"
            InputProps={{
              inputComponent: NumberFormatCustomPercen
            }}
            variant="outlined"
          />
          <TextField
            label="Anticipo"
            value={this.state.anticipo}
            onChange={e => this.updateAnticipo(e.target.value)}
            className={classes.textField}
            margin="normal"
            InputProps={{
              inputComponent: NumberFormatCustom
            }}
            variant="outlined"
          />
          {/* <TextField
              label="Caso Asignado a"
              value={this.state.asignadoA}
              onChange={e => this.updateAsignado(e.target.value)}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />*/}
          <div style={{ display: "flex" }}>
            <TextField
              label="Recomendado Por"
              value={this.state.recomendado}
              onChange={e => this.updateRecom(e.target.value)}
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />
            <div style={{ width: "20%", marginRight: "10px" }}>
              <Autocomplete2
                disabled={window.respuesta.checkedE ? false : true}
                id="combo-box-nombre"
                // className={classes.textField}
                value={this.state.asignadoA}
                onChange={(obj, str) => this.updateAsignado(str)}
                onClose={params =>
                  console.log(params.target.value, "on closee!!")
                }
                options={
                  this.props.usuarios
                    ? this.props.usuarios
                        .filter(
                          i => i.rol === "operador" || i.rol === "administrador"
                        )
                        .map(i => {
                          return i.nombre;
                        })
                    : null
                }
                // getOptionLabel={option => option.nombre}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Asignado a"
                    margin="normal"
                    variant="outlined"
                    className={classes.textField}
                    fullWidth
                  />
                )}
              />
            </div>{" "}
          </div>
        </Paper>
        <div>
          <TextField
            label="Descripcion del Caso"
            multiline
            rows="5"
            style={{ width: "90%" }}
            className={classes.textField}
            margin="normal"
            variant="outlined"
            value={this.state.descripcion}
            onChange={e => this.updateDesc(e.target.value)}
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          {window.respuesta.checkedC ? (
            <>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.estado === 1}
                      onChange={this.updateInactivo}
                      color="primary"
                    />
                  }
                  label={this.state.estado === 1 ? "Activado" : "Desactivado"}
                />
              </FormGroup>

              <Button onClick={this.save} variant="contained" color="primary">
                Guardar
              </Button>
            </>
          ) : null}
        </div>
        <Dialog
          open={this.state.open}
          onClose={this.consluir}
          aria-labelledby="form-dialog-title"
        >
          <Conclusion
            consluir={this.consluir}
            descr={this.state.descr}
            guardarConclusion={this.guardarConclusion}
            text={
              this.state.estado === 2
                ? "Desactivacion del Caso"
                : "Activacion del Caso"
            }
            setDescr={this.setDescr}
          />
        </Dialog>
        <AddDialog
          openAdd={this.state.openAdd}
          addText={this.state.addText}
          addMateria={this.state.addMateria}
          addSeccion={this.state.addSeccion}
          datosAutoc={
            datosAutoc
              ? datosAutoc.filter(i => i.seccion === "materia" && i.activo)
              : null
          }
          handleClose={this.handleClose}
          handleAdd={this.handleAdd}
          updateAddText={this.updateAddText}
          updateAddMateria={this.updateAddMateria}
        />
        <Dialog
          /*fullScreen */

          open={this.state.open2}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <div>
            <form
              className={classes.container}
              onSubmit={this.handleAddUser}
              autoComplete="off"
            >
              <DialogTitle id="form-dialog-title">Agregar Cliente</DialogTitle>
              <DialogContent>
                <DialogContentText> </DialogContentText>
                {/*** Nombre de USUARIO ***/}
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  value={this.state.text}
                  onChange={e => this.setState({ text: e.target.value })}
                  label="Nombre"
                  variant="outlined"
                  type="name"
                  fullWidth
                  required
                />
                {/*** CORREO ELECTRONICO ***/}
                <TextField
                  margin="dense"
                  id="email"
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value })}
                  label="correo electronico"
                  variant="outlined"
                  type="name"
                  fullWidth
                  required
                />
                {/*** CONTRASEñA ***/}
                <TextField
                  margin="dense"
                  id="name"
                  value={this.state.rfc}
                  onChange={e => this.setState({ rfc: e.target.value })}
                  label="RFC"
                  variant="outlined"
                  type="name"
                  fullWidth
                  required
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose2} color="primary">
                  Cancelar
                </Button>
                <Button variant="outlined" color="primary">
                  Guardar
                </Button>
              </DialogActions>
            </form>
          </div>
        </Dialog>{" "}
        <SnackBar
          open={this.state.guardado}
          exito={this.state.exito}
          handleClose={() => {
            this.setState({ guardado: false, exito: false });
          }}
        />
      </div>
    );
  }

  consluir = () => {
    this.setState({ open: !this.state.open });
  };

  handleAddUser = async e => {
    e.preventDefault();
    try {
      const f = await firebase2.register(
        this.state.text,
        this.state.email,
        this.state.rfc,
        "cliente"
      );

      this.setState({ guardado: true, exito: f, open2: false });
    } catch (error) {
      console.log(error.message);
      this.setState({
        open2: false
      });
    }
  };

  guardarConclusion = async () => {
    this.setState({ open: !this.state.open });
  };
  setDescr = e => {
    this.setState({ descr: e.target.value });
  };
  updateInactivo = async () => {
    await this.setState({ estado: this.state.estado === 2 ? 1 : 2 });
    this.setState({ open: !this.state.open });
    //this.update()
  };

  updateNombre = val => {
    this.setState({ text: val });
    this.setState({
      email: this.props.usuarios
        .filter(i => i.nombre === val)
        .map(i => {
          return i.email;
        })
    });
    this.setState({
      rfc: this.props.usuarios
        .filter(i => i.nombre === val)
        .map(i => {
          return i.contra;
        })
    });
  };

  updateEmail = val => {
    this.setState({ email: val });
    this.setState({
      nombre: this.props.usuarios
        .filter(i => i.email === val)
        .map(i => {
          return i.nombre;
        })
    });
    this.setState({
      rfc: this.props.usuarios
        .filter(i => i.email === val)
        .map(i => {
          return i.contra;
        })
    });
  };
  updateAsignado = val => {
    this.setState({ asignadoA: val });
  };

  updateBody = async val => {
    await this.setState({ text: val });
    //this.update()
  };
  updateTitle = async val => {
    await this.setState({ title: val });
    // this.update()
  };
  updateDomicilio = async val => {
    await this.setState({ domicilio: val });
    // this.update()
  };
  updateTelefono = async val => {
    await this.setState({ telefono: val });
    // this.update()
  };
  updateCelular = async val => {
    await this.setState({ celular: val });
    // this.update()
  };
  updateEmail = async val => {
    await this.setState({ email: val });
    // this.update()
  };
  updateCurp = async val => {
    await this.setState({ curp: val });
    // this.update()
  };
  updateRFC = async val => {
    await this.setState({ rfc: val });
    // this.update()
  };
  updateAseg = async val => {
    await this.setState({ aseguradora: val, addText: val });
    // this.update()
  };
  updateRamo = async val => {
    await this.setState({ ramo: val, addText: val });
    // this.update()
  };
  updateSeguro = async val => {
    await this.setState({ tiposeguro: val, addText: val });
    // this.update()
  };
  updateAsunto = async val => {
    await this.setState({ asunto: val, addText: val });
    // this.update()
  };
  updateFianza = async val => {
    await this.setState({ monto: val });
    // this.update()
  };
  updateDesc = async val => {
    await this.setState({ descripcion: val });
    // this.update()
  };
  updateContrato = async val => {
    await this.setState({ contrato: val });
    // this.update()
  };
  updateHonor = async val => {
    await this.setState({ honorarios: val });
    // this.update()
  };
  updateAnticipo = async val => {
    await this.setState({ anticipo: val });
    // this.update()
  };
  updateAsignado = async val => {
    await this.setState({ asignadoA: val });
    // this.update()
  };
  updateRecom = async val => {
    await this.setState({ recomendado: val });
    // this.update()
  };
  updateAddText = async val => {
    await this.setState({ addText: val });
  };
  updateAddMateria = async val => {
    await this.setState({ addMateria: val });
  };
  addAseguradora = () => {
    this.setState({
      //addText: "",
      addMateria: "",
      //isEdit: false,
      //idElem: "",
      indexTab: 1,
      addSeccion: "instituciones",
      openAdd: !this.state.openAdd
    });
  };
  addRamo = () => {
    this.setState({
      //addText: "",
      addMateria: "",
      //isEdit: false,
      //idElem: "",
      addSeccion: "materia",
      openAdd: !this.state.openAdd
    });
  };
  addTiposeguro = () => {
    this.setState({
      //addText: "",
      addMateria: "",
      //isEdit: false,
      //idElem: "",
      indexTab: 3,
      addSeccion: "reclamos",
      openAdd: !this.state.openAdd
    });
  };
  addAsunto = () => {
    this.setState({
      //addText: "",
      addMateria: "",
      //isEdit: false,
      //idElem: "",
      addSeccion: "asuntos",
      openAdd: !this.state.openAdd
    });
  };
  handleAdd = async () => {
    await firebase
      .firestore()
      .collection("datosAutocompletado")
      .add({
        text: this.state.addText,
        materia: this.state.addMateria,
        seccion: this.state.addSeccion,
        activo: true
      });
    await this.setState({ addText: "", openAdd: false });
  };
  handleClose = () => {
    this.setState({
      //addText: "",
      //addMateria: "",
      //isEdit: false,
      //idElem: "",
      openAdd: !this.state.openAdd
    });
  };
  handleClose2 = () => {
    this.setState({
      open2: false
    });
  };

  onCloseAutocompleteS = async () => {
    const disponible = await this.props.datosAutoc
      .filter(i => i.seccion === "instituciones" && i.activo)
      .filter(i => i.text === this.state.aseguradora);
    this.setState({ addAseguradora: !disponible.length > 0 });
  };

  onCloseAutocompleteRamo = async () => {
    const disponible = await this.props.datosAutoc
      .filter(i => i.seccion === "materia" && i.activo)
      .filter(i => i.text === this.state.ramo);
    this.setState({ addRamo: !disponible.length > 0 });
  };

  onCloseAutocompleteTipoSeg = async () => {
    const disponible = await this.props.datosAutoc
      .filter(i => i.seccion === "reclamos" && i.activo)
      .filter(i => i.text === this.state.tiposeguro);
    this.setState({ addTiposeguro: !disponible.length > 0 });
  };
  onCloseAutocompleteAsunto = async () => {
    const disponible = await this.props.datosAutoc
      .filter(i => i.seccion === "asuntos" && i.activo)
      .filter(i => i.text === this.state.asunto);
    this.setState({ addAsunto: !disponible.length > 0 });
  };
  save = async () => {
    await this.props.noteUpdate(this.state.id, {
      title: this.state.title,
      body: this.state.text,
      domicilio: this.state.domicilio,
      telefono: this.state.telefono,
      celular: this.state.celular,
      email: this.state.email,
      curp: this.state.curp,
      rfc: this.state.rfc,
      aseguradora: this.state.aseguradora,
      ramo: this.state.ramo,
      tiposeguro: this.state.tiposeguro,
      asunto: this.state.asunto,
      descripcion: this.state.descripcion,
      monto: this.state.monto,
      contrato: this.state.contrato,
      honorarios: this.state.honorarios,
      anticipo: this.state.anticipo,
      asignadoA: this.state.asignadoA,
      recomendado: this.state.recomendado,
      estado: this.state.estado,
      actualizado: this.props.selectedNote.name,
      descr: this.state.descr
    });
  };
}
export default withStyles(styles)(EditorComponent);
